export function pointInCircle(cx, cy, r, x, y) {
    var dx = x - cx;
    var dy = y - cy;
    return dx * dx + dy * dy < r * r;
}
export function pointInCircleStroke(cx, cy, r, lineWidth, x, y) {
    return (pointInCircle(cx, cy, r + lineWidth / 2, x, y) &&
        !pointInCircle(cx, cy, r - lineWidth / 2, x, y));
}
